import React, { Fragment, useEffect, useState } from 'react';
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import { Row, Col, Card, CardBody, Button,Label, InputGroup } from "reactstrap";
import { providers,providersSelectList } from './assets/css/constants';
import Form from '../../Common/Form';
import Select from "react-select";
import requestApi from '../../services/requestApi.service';
import { confirmBox, handleErrorResponse, parseJSON, showToast,getTimeDiff, translateContent,getWarningIcon, addAgentToSyncList, handelCommonChangeAgent, handleCommonRemoveAgent, getAgentByApiCommon, getEncodeData, getDecodeData, getKnowledgeByApiCommon, addKBToSyncList, isApiAlreadyMapped, getImportInfoByApiCommon, addImportInfoToSyncList } from '../../Common/Appcommon';
import Loading from '../../Common/Loading';
import TooltipItem from '../../Common/ToolTip';

const ProviderCredentials = (props) => {
    const {accountInfo} = props;
    let {data_row} = accountInfo;
    //const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors }, setError } = useForm();
    const [formData, setFormData] = useState({concurrency_limit:8,create_contact_allowed :true});
    const [selectProviderList, setSelectproviderList] = useState(providersSelectList[0]);
    const [provider , setProvider] = useState(providersSelectList[0].value);
    const [showButtonLoading,setShowButtonLoading] = useState(false);
    const [lastSyncTime ,setLastSyncTime] = useState("");
    const [lastSyncStatus , setStatus] = useState(true);
    const [currentAgents, setCurrentAgents] = useState([]); 
    const [selectAgentList, setSelectAgentList] = useState([]);
    const [selecteSyncAgents, setSelecteSyncAgents] = useState([]);
    const [getAgent,setGetAgent] = useState(true);
    const [syncAllAgent, setSyncAllAgent] = useState(false);
    const [syncAllKB, setSyncAllKB] = useState(false);
    const [currentKB,setCurrentKB] = useState([]);
    const [selectKBList, setSelectKBList] = useState([]);
    const [selecteSyncKB, setSelecteSyncKB] = useState([]);
    const [getKB,setGetKB] = useState(true);
    const [hideSyncAllAgent , setHideSyncAllAgent] = useState(false);
    const [hideSyncAllKB,setHideSyncAllKB] = useState(false);
    const [tmpData,setTmpData] = useState([]);

    useEffect(async () => {
        await getproviderData();
        await getLastSyncTime();
        await getAgentbyAppid();
        await getKBbyAppid();
    }, []);

    useEffect(() => {
        /*if (syncAllAgent) {
          fetchProviderData("agent");
        }
        if (syncAllKB) {
          fetchProviderData("knowledge");
        }*/
      }, [syncAllAgent, syncAllKB]);
    
    /*
        const numbers = [1, 2, 3, 4];
        reduce() is a method in JavaScript used to "reduce" an array into a single value, 
        typically an object, array, or even a number. 
        It applies a function to each item in the array and accumulates a result, which is passed on to the next iteration.
        // Using reduce to sum the numbers
        const sum = numbers.reduce((acc, num) => {
            return acc + num;
        }, 0);  // Initial accumulator value is 0
    */

    /* const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    } */
    const handleApiMappingCheck = async (provider,formData) =>{
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let proData = getEncodeData(formData, appid);
        let resA = await isApiAlreadyMapped(provider, proData, appid, 'Agent', 'spec',true);
        let resKb = await isApiAlreadyMapped(provider, proData, appid, 'Knowledge', 'spec',true);
        setHideSyncAllAgent(!resA);
        setHideSyncAllKB(!resKb);
    }
    const fetchProviderData = async (name) => {
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let encodedData = getEncodeData(formData,appid);
    
        try {
            if (name === "agent") {
                const Agentresponse = await getImportInfoByApiCommon(provider,name, encodedData, appid);
                const Agentdata = Agentresponse.data[0];
                setSelecteSyncAgents(Agentdata);
            } else if (name === "knowledge") {
                const KBresponse = await getImportInfoByApiCommon(provider,name, encodedData, appid);
                const KBdata = KBresponse.data[0];
                setSelecteSyncKB(KBdata);
            }
        } catch (error) {
            console.error("Error fetching provider data:", error);
        }
    };
    const onClickGetDetailsByApi = async (formData,name) =>{
        if(name === 'agent'){
            await getAgentbyApi(provider,formData,true);
        }else if(name === 'knowledge'){
            await getKBbyApi(provider,formData,true);
        }
    }

    const handelRadioBtnChange = (All,name) =>{
        if(name ===  'agent'){
            setSyncAllAgent(All);
            if(selectAgentList.length <= 0){
                setGetAgent(true);
                if(!All){
                    setSelecteSyncAgents([]);
                }
            }
        }else if (name === 'knowledge'){
            setSyncAllKB(All);
            if(selectKBList.length <= 0){
                setGetKB(true);
            }
        }
    }
    const getAgentbyApi = async (provider,formData,onclick = false) =>{
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        if(provider !== ""){
            if(formData[provider+'_api_key']){
                let providerData = getEncodeData(formData,appid);
                let response = await getImportInfoByApiCommon(provider,"agent",providerData,appid);
                if(response.issuccess){
                    let data = response.data[0];
                    setCurrentAgents(data);
                    if(onclick){
                        setGetAgent(false);
                        if(data && data.length > 0){
                            onAddMoreVariants(1,'agent');
                        }
                    }
                }else{
                    let message = response.errormsg;
                    if(message === ""){
                        message = translateContent("vm.get.api.sync.failed",{label:'Agent'});
                    }
                    handleErrorResponse(message)
                }
            }
        }
    }
    const getAgentbyAppid = async () =>{
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "FETCH_IMPORT_DETAILS",
            "SUBACCOUNTID": appid,
            "TYPE" : "agent",
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let data = response.data[1];
            let newList = [];
            let synAll = response.data[2];
            setSyncAllAgent(synAll)
            if(data && !synAll){
                for (let vi = 0; vi < data.length ; vi++) {
                    newList.push({ value: data[vi] });
                }
                setSelectAgentList(newList);
                setSelecteSyncAgents(
                    newList.map(item => item.value).filter(Boolean)
                );
                if(newList.length > 0){
                    setGetAgent(false);
                }else{
                    setGetAgent(true);
                }
            }
        }else{
            let message = response.errormsg ?? "";
            showToast(message, "top-right", "error");
        }
    }

    const getKBbyApi = async(provider,formData,onclick = false) => {
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        if(provider !== ""){
            if(formData[provider+'_api_key']){
                let providerData = getEncodeData(formData,appid);
                let response = await getImportInfoByApiCommon(provider,"knowledge",providerData,appid)
                if(response.issuccess){
                    let data = response.data[0];
                    setCurrentKB(data);
                    if (onclick) {
                        setGetKB(false);
                        if (data&& data.length > 0) {
                            onAddMoreVariants(1, 'knowledge');
                        }
                    }
                }else{
                    let message = response.errormsg;
                    if(message === ""){
                        message = translateContent("vm.get.api.kb.failed");
                    }
                    handleErrorResponse(message)
                }
            }
        }
    }
    const getKBbyAppid = async () =>{
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "GET_SYNC_KB",
            "SUBACCOUNTID": appid,
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let data = response.data[1];
            let synAll = response.data[2];
            setSyncAllKB(synAll);
            let newList = [];
            if(data && !synAll){
                for (let vi = 0; vi < data.length ; vi++) {
                    newList.push({ value: data[vi] });
                }
                setSelectKBList(newList);
                setSelecteSyncKB(
                    newList.map(item => item.value).filter(Boolean)
                );
                if(newList.length > 0){
                    setGetKB(false);
                }else{
                    setGetKB(true);
                }
            }
        }else{
            let message = response.errormsg ?? "";
            showToast(message, "top-right", "error");
        }
    }
    const onAddMoreVariants = (variationCount, name) => {
        const setter = name === 'agent' ? setSelectAgentList : setSelectKBList;
        const currentList = name === 'agent' ? selectAgentList : selectKBList;
        const newList = [
            ...currentList,
            ...Array.from({ length: variationCount }, () => ({ value: null }))
        ];
        setter(newList);
    };
    
    
    const handleAgentChange = async (selectedOption, index) => {
        const [updatedList, updatedSyncAgents, updatedAgents]  = await handelCommonChangeAgent(selectedOption, index,selectAgentList, currentAgents ,selecteSyncAgents)
        setSelectAgentList(updatedList);
        setSelecteSyncAgents(updatedSyncAgents);
        setCurrentAgents(updatedAgents);
    };

    const removeVariant = async (index) => {
        const [updatedList, updatedSyncAgents, updatedCurrentAgents] = await handleCommonRemoveAgent(index, selectAgentList, currentAgents);
        setSelectAgentList(updatedList);
        setSelecteSyncAgents(updatedSyncAgents);
        setCurrentAgents(updatedCurrentAgents);
    };
    const handleKnowledgeChange = async (selectedOption,index) =>{
        const [updatedList, updatedSyncKnowledge, updatedKnowledge]  = await handelCommonChangeAgent(selectedOption, index,selectKBList, currentKB ,selecteSyncKB)
        setSelectKBList(updatedList);
        setSelecteSyncKB(updatedSyncKnowledge);
        setCurrentKB(updatedKnowledge);
    }
    const removeKnowledgeVariant = async (index) =>{
        const [updatedList, updatedSyncKnowledge, updatedKnowledge] = await handleCommonRemoveAgent(index, selectKBList, currentKB);
        setSelectKBList(updatedList);
        setSelecteSyncKB(updatedSyncKnowledge);
        setCurrentKB(updatedKnowledge);
    } 

    const updateSyncDetails = async (name) =>{
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let providerData = getEncodeData(formData,appid);
        let response ;
        if(name === 'agent'){
            response = await addImportInfoToSyncList(appid,selecteSyncAgents,provider,providerData,syncAllAgent,name);
        }else if(name === 'knowledge'){
            response = await addImportInfoToSyncList(appid,selecteSyncKB,provider,providerData,syncAllKB,name);
        }
        return response;
    }

    const deleteSyncKB = async () =>{
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "REMOVE_SELECTED_KB",
            "SUBACCOUNTID": appid,
        }
        let response = await requestApi.processServerRequest(params);
        return response;  
    }

    const deleteSyncAgent = async () =>{
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "REMOVE_SELECTED_AGENT",
            "SUBACCOUNTID": appid,
        }
        let response = await requestApi.processServerRequest(params);
        return response;
    }

    const deleteSyncNumber = async () =>{
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "REMOVE_SELECTED_NUMBER",
            "SUBACCOUNTID": appid,
        }
        let response = await requestApi.processServerRequest(params);
        return response;
    }
    
    const submitProviderCredentials = async (name,formData) => {
        setShowButtonLoading(true);
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let providerData = getEncodeData(formData,appid);
        let errormsgResponces = [];
        let errorMessage = "";
        /*let syncAgentresponse = await updateSyncDetails('agent');
        if(!syncAgentresponse.issuccess){
            errorMessage = translateContent("vm.update.api.sync.failed",{label:'agent'});
            errormsgResponces['agentError'] = errorMessage
            // handleErrorResponse(translateContent("vm.update.api.sync.failed",{label:'agent'}));
        }
        let syncKBresponce = await updateSyncDetails('knowledge');
        if(!syncKBresponce.issuccess){
            errorMessage = translateContent("vm.update.api.sync.failed",{label:'knowledge base'});
            errormsgResponces['kbError'] = errorMessage;
            // handleErrorResponse(translateContent("vm.update.api.sync.failed",{label:'knowledge base'}));
        }*/
        let sync = (data_row?.status !== undefined && data_row.status.toLowerCase() === "active" ? true :  false)
        let params = {
            'ENTITY': 'AIPROCESSOR',
            'OPERATION' : 'SAVE_API_DETAILS',
            'PROVIDER_DATA' : providerData,
            'PROVIDER' : provider,
            'ACCOUNT_ID' : data_row.account_id,
            "SUBACCOUNTID" : appid,
            "isSync" : sync,
            "SYNCOPERATION" : "call",
        };
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            showToast(translateContent("vm.subaccount.provider.save.msg"));
            await getproviderData();
            await getAgentbyAppid();
            await getKBbyAppid();
            await getLastSyncTime();
            setShowButtonLoading(false);
        }else{
            // if(response.errormsg !== ""){
            //     handleErrorResponse(response.errormsg);
            // }else{
                // handleErrorResponse(translateContent("vm.subaccount.provider.error.msg"));
                let isValid =  response?.data?.[0]?.[0];
                errorMessage = translateContent("vm.subaccount.sync.failed");
                errormsgResponces['apiError'] = errorMessage
                
                if(!isValid){
                    errorMessage =  translateContent("vm.subaccount.provider.error.msg");
                    errormsgResponces['apiError'] = errorMessage  
                }
            // }
            setShowButtonLoading(false);
        }
        return errormsgResponces;
    }

    const getproviderData = async () => {
        
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let params = {
            'ENTITY': 'AIPROCESSOR',
            'OPERATION' : 'GET_API_DETAILS',
            "SUBACCOUNTID" : appid
        };
        setShowButtonLoading(true);
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let data = response.data['providerDetails'];
            data = getDecodeData(data,appid);
            let customProvider = response.data['provider'];
            let syncStatus = response.data['syncStatus'] !== undefined && response.data['syncStatus'] !== null && response.data['syncStatus'] !== "" ? response.data['syncStatus'] : lastSyncStatus;
            if(syncStatus !== ""){
                setStatus(syncStatus);
            }
            if(data !== undefined && data.length > 0){
                data = parseJSON(data);
                setFormData({...data,
                    concurrency_limit: (data.concurrency_limit) || 8, 
                });
                setProvider(customProvider); 
                if(customProvider === "vapi"){
                    setSelectproviderList(providersSelectList[0]);
                }else if(customProvider === "bland"){
                    //setSelectproviderList(providersSelectList[1]);
                }else if(customProvider === "retell"){
                    setSelectproviderList(providersSelectList[1]);
                }
                // await getAgentbyApi(customProvider,data);   
                // await getKBbyApi(customProvider,data);
                //await handleApiMappingCheck(customProvider,data);
            }
        }
        setShowButtonLoading(false);
    }

    const getLastSyncTime = async() =>{
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let params = {
            'ENTITY': 'AIPROCESSOR',
            'OPERATION' : 'GET_LAST_SYNC_TIME',
            'subAccountId':appid
        };
        let response = await requestApi.processServerRequest(params);
        if (response.issuccess) {
            let previousSyncTime = new Date(response.data[0]+ " UTC");
            let timeDiff = getTimeDiff(previousSyncTime);
            setLastSyncTime(timeDiff);
        }else{
            setLastSyncTime('N/A');
        }
        
    }

    const syncProviderDetails = async() =>{
        setShowButtonLoading(true);
        if(!!tmpData){
            let prvKey = tmpData[provider+'_api_key'];
            let pubKey = tmpData[provider+'_pub_key'];
            if(prvKey.trim()=== ''){
                handleErrorResponse(translateContent("vm.provider.sync.error",{Key:'api'}));
                setShowButtonLoading(false);
                return;
            }else if(provider === 'vapi' && pubKey.trim() === ''){
                handleErrorResponse(translateContent("vm.provider.sync.error",{Key:'public'}));
                setShowButtonLoading(false);
                return;
            }
        }
       
        /*let errormsgResponces = [];
        let errorMessage = "";
        let syncAgentresponse = await updateSyncDetails('agent');
        if(!syncAgentresponse.issuccess){
            errorMessage = translateContent("vm.update.api.sync.failed",{label:'agent'});
            errormsgResponces['agentError'] = errorMessage
        }
        let syncKBresponce = await updateSyncDetails('knowledge');
        if(!syncKBresponce.issuccess){
            errorMessage = translateContent("vm.update.api.sync.failed",{label:'knowledge base'});
            errormsgResponces['kbError'] = errorMessage;
        }*/
        let appid = (data_row.appid !== undefined && data_row.appid) !== "" ? data_row.appid : "";
        let sync = (data_row?.status !== undefined && data_row.status.toLowerCase() === "active" ? true :  false);
        if(!sync){
            showToast(translateContent("vm.account.status.error"));
            setShowButtonLoading(false);
            return;
        }
        let params = {
            'ENTITY': 'AIPROCESSOR',
            'OPERATION' : 'SYNC_API_DETAILS',
            "SUBACCOUNTID" : appid,
            "SYNCOPERATION" : "call",
        };
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            await getLastSyncTime();
            showToast(translateContent("vm.subaccount.cred.sync.msg"));
            setShowButtonLoading(false);
        }else{
            setShowButtonLoading(false);
            handleErrorResponse(translateContent("vm.subaccount.cred.sync.error"));
        }
    }
    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const handleChange = async(option) =>{
        if(formData[provider+"_api_key"] !== undefined && formData[provider+"_api_key"] !== null && formData[provider+"_api_key"] !== ""){
            if(provider !== option.value){
                let confirm = await confirmBox("Warning!", translateContent("vm.subaccount.cred.change.msg",{provider: capitalizeFirstLetter(provider), newprovider: capitalizeFirstLetter(option.value)}),"diamond-exclamation", translateContent("vm.general.continue") , 'No'); // All "+provider+" related details will be removed, and "+option.value+"  will be reconfigured from scratch. Do you want to proceed?"
                if(!confirm){
                    return;
                }
            }else{
                return;
            }
        }
        setCurrentAgents([]); 
        setSelectAgentList([]);
        setSelecteSyncAgents([]);
        setGetAgent(true);
        setCurrentKB([]);
        setSelecteSyncKB([]);
        setSelectKBList([]);
        setGetKB(true);
        setSelectproviderList(option);
        setProvider(option.value);
        setFormData({});
    }

    const manualSync = (tmpData) =>{
        let providerName = selectProviderList.value;
        setTmpData(tmpData);
        return(
            <div className=''>
                {
                    
                    Object.keys(formData).length > 0 && 
                    (
                    <div>
                    <Button size="lg" className='theme-bg-g d-flex flex-end' onClick={syncProviderDetails}>
                        {"Sync Call Logs"}
                        <span className={"ps-1 hide"}><TooltipItem id={'2'} text={"Sync will pull all past data into this client account"} content={<i class="fi fi-ss-info"></i>}/></span>
                        {/* Sync {providerName.toUpperCase()+' Account'} */}
                    </Button>
                    </div>
                    )
                }
            </div>
        )
    }
    return (
    <Loading showLoader={showButtonLoading} mainContent={
        <Fragment>

          
            <div className='provider-container'>
                <div className='d-flex mb-3'>
                    <Col className='w-100'>
                        <Select
                            isClearable={false}
                            onChange={(eve) => {
                                handleChange(eve)
                            }}
                            placeholder={"Choose a ai name"}
                            options={providersSelectList}
                            value={selectProviderList}
                            className='provider-creaditials-select basic-multi-select me-4 p-0'
                            classNamePrefix="wa-select"
                            isSearchable={false}
                        />
                    </Col>
                    <Col>
                        <Row>
                            <div className='d-flex justify-content-end'>
                                <div className='me-2'>
                                {
                                    (provider === "vapi" || provider === "bland" || provider === "retell") && (
                                        <div className='mt-0'>
                                            {/* <Label>Status</Label> */}
                                            {/* <Button size="lg" className={`btn btn-secondary ${lastSyncStatus ? 'sub-sts-active' : 'sub-sts-pym-fail'}`}>
                                                {lastSyncStatus ? 'Active' : 'Inactive'}
                                            </Button> */}
                                            <div className='d-flex align-items-center pt-2'>
                                                <label className={`${lastSyncStatus ? 'sub-sts-active' : 'sub-sts-pym-fail'} status-indicator`}>
                                                </label>
                                                <div className='pt-0 d-flex'>
                                                    <span className='d-flex justify-content-end font-bold black-color'> {lastSyncStatus ? 'Connected ,' : 'Not Connected'}<div class={lastSyncStatus ? "ps-1 black-color" : "hide"}>Last Sync: {lastSyncTime}</div></span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                </div>
                                {/* <div className='me-2'>
                                    {manualSync()}
                                </div> */}
                            </div>
                        </Row>
                        {false && <Row className={'hide'}>
                            <span className='d-flex justify-content-end'>
                                <div className='pt-2 d-flex black-color'>
                                    <span class="">Last sync time: {lastSyncTime}</span>
                                </div>
                            </span>
                        </Row>}
                    </Col>
                </div>
                <div>
                    <Row>
                        {providers.map((provider) => {
                            const { name, label, url, description, fields } = provider;
                            const {data_row} = accountInfo;
                            let providerName = selectProviderList.value;
                            if(name === selectProviderList.value){
                                return (
                                    <Fragment>
                                        {
                                        (providerName !== "") ? (
                                        <Col md={12}>
                                            <Card>
                                                <CardBody className='agency-details'>
                                                    <div className='col-md-12 card-fields pb-3 bb-1'>
                                                        <Row>
                                                            <>
                                                                <Col md={7}>
                                                                    <div class="d-grid">
                                                                        <span class="provider-header">{label} 
                                                                            <a className="ps-2" tooltip="The providers API page" target='_blank' rel="noreferrer" href={url}><i className="pe-7s-link"></i></a>
                                                                        </span>
                                                                        <span class="header-desc">{description}</span>
                                                                    </div>
                                                                </Col>
                                                                {/* <Col md={5}>
                                                                <div className='d-flex justify-end'>
                                                                    {
                                                                        
                                                                        Object.keys(formData).length > 0 && 
                                                                        (
                                                                        <Button size="lg" className='theme-bg-g d-flex flex-end' onClick={syncProviderDetails}>
                                                                            Sync {providerName.toUpperCase()+' Account'}
                                                                        </Button>
                                                                        )
                                                                    }
                                                                </div>
                                                                </Col> */}
                                                            </>
                                                        </Row>
                                                        <div className='pt-2 d-flex flex-row-reverse hide'>
                                                            <span class="">Last sync time: {lastSyncTime}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Form 
                                                            submitAction={submitProviderCredentials} 
                                                            pname={name} 
                                                            fields={fields} 
                                                            formData={formData} 
                                                            account_id={data_row.account_id !== undefined && data_row.account_id !== "" ? data_row.account_id : ""} 
                                                            lastSyncTime={lastSyncTime} 
                                                            syncStatus={lastSyncStatus} 
                                                            submitBeforebtn = {manualSync} 
                                                            handleAgentChange={handleAgentChange} 
                                                            onAddMoreVariants = {onAddMoreVariants} 
                                                            removeVariant={removeVariant} 
                                                            selectAgentList={selectAgentList} 
                                                            currentAgents={currentAgents} 
                                                            onClickGetDetailsByApi={onClickGetDetailsByApi} 
                                                            getAgent = {getAgent} 
                                                            syncAllAgent = {syncAllAgent} 
                                                            syncAllKB = {syncAllKB} 
                                                            currentKB={currentKB}
                                                            selectKBList ={selectKBList}
                                                            handelRadioBtnChangeCommon = {handelRadioBtnChange}
                                                            selecteSyncKB ={selecteSyncKB} 
                                                            setSelecteSyncKB = {setSelecteSyncKB}
                                                            getKB = {getKB}
                                                            removeKnowledgeVariant={removeKnowledgeVariant}
                                                            handleKnowledgeChange={handleKnowledgeChange}
                                                            hideSyncAllKB={hideSyncAllKB}
                                                            hideSyncAllAgent={hideSyncAllAgent}
                                                            hide = {true}
                                                        />
                                                    </div> 
                                                </CardBody>
                                            </Card>
                                        </Col>
                                             )
                                        : 
                                        <div className='not-valid-provider'>
                                        <span>Coming Soon</span>
                                        </div>}
                                    </Fragment>
                                )
                            }
                            return null;
                        })}
                    </Row>
                </div>
            </div>
        </Fragment>
    }/>
    )
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProviderCredentials);
